( function () {
	'use strict';

	function reportAccordion () {
		function link ( scope ) {
			scope.open    = true;
			scope.openSec = true;
		}

		return {
			'templateUrl' : '/templates/report/report-components/report-accordion/report-accordion.html',
			'link'        : link,
			'scope'       : {
				'graphOptions' : '=',
				'graphData'    : '=',
				'headerTitle'  : '@',
				'graphSecData' : '=',
				'graphId'      : '@',
				'template'     : '='
			}
		};
	}

	angular.module( 'app.report' )
		.directive( 'reportAccordion', reportAccordion );
} )( );
